import { render } from "./SendOtp.vue?vue&type=template&id=5c9dcd1e"
import script from "./SendOtp.vue?vue&type=script&lang=js"
export * from "./SendOtp.vue?vue&type=script&lang=js"

import "./SendOtp.vue?vue&type=style&index=0&id=5c9dcd1e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__